import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'

const Pricing = () => {
  return (
    <main className="pt-20">
      <section className="section bg-white">
        <div className="container">
          <motion.div
            className="text-center max-w-4xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Simple, Transparent Pricing
            </h1>
            
            <p className="text-xl text-gray-600 mb-12">
              Pay only for what you use. No hidden fees, no long-term contracts. 
              Scale up or down anytime.
            </p>

            <div className="bg-gradient-to-r from-primary-50 to-accent-50 p-12 rounded-3xl border border-primary-100">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                🚧 Full Pricing Page Coming Soon
              </h2>
              
              <p className="text-lg text-gray-600 mb-8">
                We're building detailed pricing tiers, advanced calculators, and billing options.
                In the meantime, check out our pricing preview on the homepage!
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link to="/#pricing" className="btn btn-primary">
                  View Pricing Preview
                </Link>
                <Link to="/demo" className="btn btn-outline">
                  Book a Demo Instead
                </Link>
              </div>
            </div>

            <div className="mt-16 text-center">
              <p className="text-gray-500 mb-4">
                Questions about pricing? 
              </p>
              <Link to="/demo" className="text-primary-500 hover:text-primary-600 font-medium">
                Talk to our team →
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </main>
  )
}

export default Pricing
